'use client'
import * as React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import Navbar from '../components/Navbar'
import { useTransform, useScroll, motion } from 'framer-motion'




export default function Overview() {

  const container1 =React.useRef(null)
  const {scrollYProgress}= useScroll({
    target:container1,
    offset:['start start', 'end end']
  })

  const BgScale= useTransform(scrollYProgress, [0,1], [1,3])

  return (
    <div sx={{height:'200vh'}} ref={container1}>
      

            <div overflow={'hidden'} >
              {/* <Grid sx={{position:'sticky', top:0, zIndex:25}}>
                <Navbar NavColor='rgba(0,0,0,0.45)' />
              </Grid> */}
              <motion.div style={{scale: BgScale}}>
              
                <div
                style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100vw', height:'100vh'}}
                >
                  <img src="/imgs/Bg2.png" alt="Bg" style={{width:'100%', }} />
                </div>
              
              </motion.div>
            </div>


        
    </div>
  )
}
